import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import AbortDebugger from "./AbortDebugger/AbortDebugger.jsx";
import { getValidPriceLevels } from "./priceLevels.js";

const rootElement = document.getElementById("react-search-application-root");

const query = {
  locations: [],
  rent: "",
  rentalTypes: [],
  extraInfos: [],
  priceLevels: [],
  page: 1,
  exchangeStudents: false,
};

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

const rent = urlParams.get("rent");
if (rent) {
  query.rent = parseInt(rent);
}

const surfaceArea = urlParams.get("surface-area");
if (surfaceArea) {
  query.surfaceArea = parseInt(surfaceArea);
}

const exchangeStudents = urlParams.get("exchangeStudents");
if (exchangeStudents) {
  query.exchangeStudents = exchangeStudents;
}

let locations = urlParams.getAll("location");
if (Array.isArray(locations)) {
  query.locations = locations;
}

const page = urlParams.get("page");
if (page) {
  query.page = page;
}

let rentalTypes = urlParams.getAll("rentalType");
if (Array.isArray(rentalTypes)) {
  query.rentalTypes = rentalTypes;
}

let extraInfos = urlParams.getAll("extraInfo");
if (Array.isArray(extraInfos)) {
  query.extraInfos = extraInfos;
}

let priceLevels = urlParams.getAll("priceLevel");
if (Array.isArray(priceLevels)) {
  query.priceLevels = getValidPriceLevels(priceLevels);
}

const abortDebug = false;

document.addEventListener("DOMContentLoaded", (e) => {
  if (!rootElement) {
    return;
  }

  const root = createRoot(rootElement);

  // Load react app only after DOM content is loaded
  root.render(
    <React.StrictMode>
      {window?.searchApp?.isLocalEnv === "1" && abortDebug ? (
        <AbortDebugger />
      ) : (
        <App query={query} />
      )}
    </React.StrictMode>,
  );
});
